// @ts-strict-ignore
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customAttributesValuesCacheKey } from "./constants";
import type { CustomAttributeValuesParams, CustomAttributeValuesResponse } from "./types";

export const getCustomAttributesValues = reactQueryFetcherAdapter(
  customAttributesValuesCacheKey,
  (signal: AbortSignal, params: CustomAttributeValuesParams): Promise<CustomAttributeValuesResponse> => {
    return fetch(customAttributesValuesCacheKey, "GET", params, { signal });
  }
);
